// extracted by mini-css-extract-plugin
export default {"project_title":"styles_project_title__IycPm","project_sub_title":"styles_project_sub_title__RQF+M"};